<div class="mat-headline-6">Books Like This</div>
<ag-carousel [slideCount]="8">
  @for (carouselItem of carouselItems; track carouselItem) {
    <ag-carousel-item [carouselItem]="carouselItem" (selectedCarouselItem)="goToFullRecord($event)">
    </ag-carousel-item>
  }
</ag-carousel>
